import requisicaoSegura from '@/auth/requisicaoSegura';
import {
  APIResponseAdicionarFichaAPlaylist,
  APIResponseFavoritarFicha,
  APIResponseJaVi,
  APIResponseListarPlaylistsUsuario,
  APIResponseVerDepoisFicha,
  ArgumentosAdicionarFichaAPlaylist,
  ArgumentosFavoritarFicha,
  ArgumentosJaVi,
  ArgumentosListarPlaylistsUsuario,
  ArgumentosVerDepoisFicha,
} from './types/playlists';

export async function listarPlaylistsUsuario(
  props: ArgumentosListarPlaylistsUsuario,
): Promise<APIResponseListarPlaylistsUsuario> {
  const response: APIResponseListarPlaylistsUsuario = await requisicaoSegura({
    endpoint: '/Usuario/MinhasListas',
    dataForm: { pagina: 0, paginacao: -1, id: props?.id },
  });

  return response;
}

export async function favoritarFicha(
  props: ArgumentosFavoritarFicha,
): Promise<APIResponseFavoritarFicha> {
  const { adicionar, fichaID } = props;

  const responseFavoritarFicha: APIResponseFavoritarFicha =
    await requisicaoSegura({
      endpoint: '/Usuario/Favoritar',
      dataForm: {
        favoritar: adicionar,
        tituloID: fichaID,
      },
    });

  return responseFavoritarFicha;
}

export async function verDepoisFicha(
  props: ArgumentosVerDepoisFicha,
): Promise<APIResponseVerDepoisFicha> {
  const { fichaID, adicionar } = props;

  const responseFavoritarFicha: APIResponseVerDepoisFicha =
    await requisicaoSegura({
      endpoint: adicionar ? '/Usuario/VerDepois' : '/Usuario/RemoverVerDepois',
      dataForm: {
        tituloID: fichaID,
      },
    });

  return responseFavoritarFicha;
}

export async function adicionarFichaAPlaylist(
  props: ArgumentosAdicionarFichaAPlaylist,
): Promise<APIResponseAdicionarFichaAPlaylist> {
  const { listaID, fichaID, adicionar } = props;

  const responseFavoritarFicha: APIResponseAdicionarFichaAPlaylist =
    await requisicaoSegura({
      endpoint: '/Usuario/SalvarTituloNaLista',
      dataForm: {
        usuarioListaID: listaID,
        tituloID: fichaID,
        adicionar,
      },
    });

  return responseFavoritarFicha;
}

export async function jaViFicha(
  props: ArgumentosJaVi,
): Promise<APIResponseJaVi> {
  const { fichaID } = props;

  const responseJaVi: APIResponseJaVi = await requisicaoSegura({
    endpoint: '/Usuario/JaVi',
    dataForm: {
      'tituloIDs[0]': fichaID,
    },
  });

  return responseJaVi;
}
